<template>
  <div class="sku-info" :class="[type, layoutClass]">
    <img :src="skuExtraInfo.background_url" alt="sku-img" class="sku-img" />
    <div class="sku-container">
      <p
        v-for="item in skuContainerData"
        :key="item.title"
        :class="item.titleClass"
      >
        {{ item.title }}
        <money-display
          v-if="item.hasMoney"
          :class="item.moneyClass"
          :number="item.money"
          :allowShowKcoin="item.allowShowKcoin"
          class="sku-money"
        />
      </p>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { isJsonString } from '@/utils/tool'
  import MoneyDisplay from '@/components/MoneyDisplay'
  import { sub } from '@/utils/accurateNumber'

  export default {
    name: 'sku-info',
    // type pay充值成功/active激活弹窗/guide引导弹窗
    props: [
      'type',
      'walletBalance',
      'realPayPrice',
      'couponPayPrice',
      'detailChannelList',
    ],
    components: {
      MoneyDisplay,
    },
    data() {
      return {}
    },
    computed: {
      ...mapState(['isDesktop', 'isTurbo', 'selectedSkuInfo']),
      layoutClass() {
        return this.isDesktop ? 'pc' : this.isTurbo ? 'gt' : 'h5'
      },
      skuExtraInfo() {
        const { skuExtraInfo } = this.selectedSkuInfo || {}
        if (skuExtraInfo && isJsonString(skuExtraInfo)) {
          return JSON.parse(skuExtraInfo) || {}
        }
        return {}
      },
      otherPrice() {
        const payMethodName = 'T-Wallet'
        let maxPrice = 0
        this.detailChannelList.map((item) => {
          if (
            item.payMethodName !== payMethodName &&
            item.channelPrice * 1 > maxPrice
          ) {
            maxPrice = item.channelPrice * 1
          }
        })
        const price = sub(maxPrice, this.realPayPrice * 1).toFixed(2)
        return price > 0 ? price : 0
      },
      needPayPrice() {
        // 需要支付的金额，商品价格 - 钱包余额
        // 如果结果小于等于0，则不需要支付，返回0
        const price = sub(this.couponPayPrice, this.walletBalance).toFixed(2)
        return price <= 0 ? 0 : price
      },
      skuContainerData() {
        const { type } = this
        // 充值成功弹窗
        if (type === 'pay') {
          return [
            {
              title: this.selectedSkuInfo.skuName,
              titleClass: 'title',
              hasMoney: false,
              allowShowKcoin: false,
            },
          ]
        }
        // 激活弹窗
        if (type === 'active') {
          return [
            {
              // T-Wallet售价
              title: this.$t('game.price_for_wallet'),
              titleClass: 'main-title',
              money: Number(this.couponPayPrice),
              moneyClass: 'main-money',
              hasMoney: true,
              allowShowKcoin: false,
            },
            {
              // 其他支付方式售价，取其他支付方式的最大值
              title: this.$t('game.other_channel_price'),
              titleClass: 'minor-title line-through',
              money: Number(this.otherPrice),
              moneyClass: 'minor-title line-through',
              hasMoney: true,
              allowShowKcoin: false,
            },
          ]
        }
        // 引导弹窗
        return [
          {
            // 账户余额 - 显示T币
            title: `${this.$t('wallet.account_balance')}:`,
            titleClass: 'minor-title',
            money: Number(this.walletBalance),
            moneyClass: 'minor-money',
            hasMoney: true,
            allowShowKcoin: true,
          },
          {
            // 商品售价 - 显示T币
            title: this.$t('game.selling_price'),
            titleClass: 'minor-title',
            money: Number(this.couponPayPrice),
            moneyClass: 'minor-money',
            hasMoney: true,
            allowShowKcoin: true,
          },
          {
            // 需要支付
            title: this.$t('game.amount_to_be_paid'),
            titleClass: 'main-title',
            money: Number(this.needPayPrice),
            moneyClass: 'main-money',
            hasMoney: true,
            allowShowKcoin: false,
          },
        ]
      },
    },
    watch: {},
    mounted() {},
    methods: {},
  }
</script>
<style scoped lang="scss">
  .sku-info {
    border: 2px solid #d7d7d7;
    border-radius: 15px;
    padding: 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: #ffffff;
    .sku-container {
      width: 100%;
    }
    .line-through {
      text-decoration: line-through;
    }

    .sku-img {
      width: 180px;
      height: 180px;
      margin-right: 45px;
      border-radius: 12px;
      background: rgba(135, 206, 231, 0.2);
    }

    ::v-deep .sku-money img.k-coin {
      width: 45px;
      height: 45px;
    }

    .title,
    .main-title {
      font: 800 45px/45px Manrope-Medium, Manrope;
      color: #000000;
      text-align: left;
    }
    .main-money {
      color: #f96000;
    }
    .minor-money {
      font-weight: 800;
      color: rgba(0, 0, 0, 0.9);
    }

    .describe {
      margin-top: 24px;
      font: 500 36px/36px Manrope-Medium, Manrope;
      text-decoration-line: line-through;
      color: #999999;
    }
    .minor-title {
      font: 500 33px/45px Manrope-Medium, Manrope;
      color: #999999;
    }
    &.guide .main-title {
      margin-top: 15px;
    }
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './SkuInfo_pc.scss';
  }
</style>
